import { render } from "./FileDocumentMultipleOutline.vue?vue&type=template&id=5683e40f"
import script from "./FileDocumentMultipleOutline.vue?vue&type=script&lang=js"
export * from "./FileDocumentMultipleOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FileDocumentMultipleOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5683e40f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5683e40f', __exports__)) {
    api.reload('5683e40f', __exports__)
  }
  
  module.hot.accept("./FileDocumentMultipleOutline.vue?vue&type=template&id=5683e40f", () => {
    api.rerender('5683e40f', render)
  })

}


export default __exports__